import { createRoot } from "react-dom/client";
import { CaptureHero } from "@/app/components/capture/CaptureHero";
import { Footer } from "@/app/components/Footer";
import "@/styles/index.css";

function CapturePage() {
  return (
    <div className="relative bg-[#0B0E14] overflow-x-hidden">
      <CaptureHero />
      <Footer />
    </div>
  );
}

createRoot(document.getElementById("root")!).render(<CapturePage />);
